<template>
  <div v-if="result" class="card-new text-slate-800">
    <div class="card-content align-middle">
      <div class="flex flex-wrap">
        <div class="w-full">
          <div class="flex justify-between">
            <div class="pt-1 pr-2 w-1/2">
              <span class="font-semibold mb-0 text-slate-700">Daily Express Shifting Requests</span><br>
              <span>Session Ends at {{ result.session_end_time}}</span>
            </div>
            <div class="text-right w-1/2">
              <p class="mb-2">Available: <span class="slot-tag m1-2">{{ result.available }}</span></p>
              <p>Total: <span class="slot-tag ml-1">{{ result.total }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({})
export default class DailyExpress extends Vue {
  private service = new BandharuService();

  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  private loading = false;

  private result = null;
  private clearingagents = null;
  private current = "shipagent";

  private form = {
    container: "",
  };

  resetResults() {
    this.result = null;
  }

  mounted() {
    this.getOverallStatistics();
  }

  getOverallStatistics() {
    this.loading = true;
    this.service
        .getDailyExpress()
        .then((res) => {
          this.result = res;
          this.loading = false;
        })
        .catch((error) => {
          console.log("Error");
          this.loading = false;
        });
  }
}
</script>
<style>
.slot-tag {
  background-color: #4299e1;
  padding: 0.1em 0.8em;
  border-radius: 4px;
  font-weight: 600;
  color: white;
}
</style>
